import { rollUpDeliveries } from '../lib/deliveries';
import type { Delivery } from '../types';

/**
 * Per-event delivery summary for the feed: a segmented bar plus the literal
 * counts. The bar is decoration; the text carries the meaning.
 */
export function DeliveryRollupCell({ deliveries }: { deliveries: Delivery[] | undefined }) {
  const rollup = rollUpDeliveries(deliveries);

  if (rollup.total === 0) {
    return <span className="rollup rollup--empty">No deliveries</span>;
  }

  const segments = [
    { key: 'succeeded', count: rollup.succeeded },
    { key: 'pending', count: rollup.pending },
    { key: 'dead_lettered', count: rollup.deadLettered },
  ].filter((segment) => segment.count > 0);

  const parts = [
    rollup.pending > 0 ? `${rollup.pending} pending` : null,
    rollup.deadLettered > 0 ? `${rollup.deadLettered} dead-lettered` : null,
  ].filter((part): part is string => part !== null);

  return (
    <div className="rollup">
      <div
        className="rollup__bar"
        role="img"
        aria-label={`${rollup.label}${parts.length > 0 ? `, ${parts.join(', ')}` : ''}`}
      >
        {segments.map((segment) => (
          <span
            key={segment.key}
            className={`rollup__segment rollup__segment--${segment.key}`}
            style={{ flexGrow: segment.count }}
          />
        ))}
      </div>
      <div className="rollup__text">
        <span className="rollup__count">{rollup.label}</span>
        {parts.length > 0 ? <span className="rollup__note">{parts.join(' · ')}</span> : null}
      </div>
    </div>
  );
}
